/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage,
} from 'react-intl';
import FaFacebook from 'react-icons/lib/fa/facebook';
import FaTwitter from 'react-icons/lib/fa/twitter';
import FaLinkedin from 'react-icons/lib/fa/linkedin';
import FaXing from 'react-icons/lib/fa/xing';
import FaMedium from 'react-icons/lib/fa/medium';
import FaInstagram from 'react-icons/lib/fa/instagram';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Footer.scss';
import navigationMessages from '../Navigation/messages';

const messages = defineMessages({
  ourCompany: {
    id: 'footer.ourCompany',
    defaultMessage: 'Our Company',
    description: 'Heading for Our Company block in footer',
  },
  ourProducts: {
    id: 'footer.ourProducts',
    defaultMessage: 'Our Products',
    description: 'Heading for Our Products block in footer',
  },
  getSmart: {
    id: 'footer.getSmart',
    defaultMessage: 'Get Smart',
    description: 'Heading for Get Smart block in footer',
  },
  copyright: {
    id: 'footer.copyright',
    defaultMessage: 'All rights reserved &copy; {year} Waltzing',
    description: 'Copyright message in footer',
  },
});

const blocks = [
  {
    id: 'ourCompany',
    name: <FormattedMessage {...messages.ourCompany} />,
    items: [
      {
        link: (
          <a
            href="http://www.waltzingatoms.com/motivation"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...navigationMessages.aboutUs} />
          </a>
        ),
      },
      {
        link: (
          <a
            href="http://www.waltzingatoms.com/career"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...navigationMessages.careers} />
          </a>
        ),
      },
      {
        link: (
          <a href="mailto:office@waltzing.at">
            <FormattedMessage {...navigationMessages.contactUs} />
          </a>
        ),
      },
      {
        link: (
          <a
            href="http://www.waltzingatoms.com/3datax"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...navigationMessages.imprint} />
          </a>
        ),
      },
    ],
  },
  {
    id: 'ourProducts',
    name: <FormattedMessage {...messages.ourProducts} />,
    items: [
      {
        link: (
          <a href="/time" target="_blank" rel="noopener noreferrer">
            Waltzing Time
          </a>
        ),
      },
      {
        link: (
          <a href="/license" target="_blank" rel="noopener noreferrer">
            Waltzing License
          </a>
        ),
      },
      {
        link: (
          <a
            href="https://www.danube.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            danube.ai
          </a>
        ),
      },
      {
        link: (
          <a
            href="http://www.waltzingatoms.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Waltzing Atoms
          </a>
        ),
      },
      {
        link: (
          <a
            href="http://creativity.waltzing.at"
            target="_blank"
            rel="noopener noreferrer"
          >
            Waltzing Creativity
          </a>
        ),
      },
    ],
  },
];

class Footer extends React.Component {
  render() {
    return (
      <div className={`${s.footer} row`}>
        <div className="col-xs-12">
          <div className={`${s.content} row`}>
            {blocks.map(block =>
              <div key={block.id} className="col-sm-4 col-xs-12">
                <h4>
                  {block.name}
                </h4>
                <ul>
                  {block.items.map((item, index) =>
                    <li key={index}>
                      {item.link}
                    </li>,
                  )}
                </ul>
              </div>,
            )}
            <div className="col-sm-4 col-xs-12">
              <h4>
                <FormattedMessage {...messages.getSmart} />
              </h4>
              <ul>
                <li>
                  <a
                    href="http://forum.waltzingatoms.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage {...navigationMessages.forum} />
                  </a>
                  <div className={s.socialMediaLinks}>
                    <a
                      href="https://www.facebook.com/waltzing.at"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook />
                    </a>
                    <a
                      href="https://twitter.com/waltzing_at"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitter />
                    </a>
                    <a
                      href="https://instagram.com/waltzing.at"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/waltzing/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin />
                    </a>
                    <a
                      href="https://www.xing.com/companies/3dataxgmbh%26cokg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaXing />
                    </a>
                    <a
                      href="https://medium.com/breaking-pad/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaMedium />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div
              className="col-xs-12 small"
              style={{
                marginTop: '25px',
              }}
            >
              <FormattedHTMLMessage
                {...messages.copyright}
                values={{
                  year: new Date().getFullYear(),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js